export const supportTutorials = [
    {
        route: '/brand/dashboard',
        title: 'Dashboard',
        video: 'https://www.loom.com/embed/5c0247e1b5064ddd818203d2a52382b3',
        locale: 'en',
        translation: {
            title: 'brand_dashboard_title',
            desc: 'brand_dashboard_desc',
        },
    },
    {
        route: '/brand/dashboard',
        title: 'Dashboard',
        video: 'https://www.loom.com/embed/f875e9f4e31a470189d4df57300f0599',
        locale: 'en',
        translation: {
            title: 'brand_dashboard_create_campaign_title',
            desc: 'brand_dashboard_create_campaign_desc',
        },
    },
    {
        route: '/brand/create/campaign/step1',
        title: 'Campaign Creation',
        video: 'https://www.loom.com/embed/f875e9f4e31a470189d4df57300f0599?t=60',
        locale: 'en',
        translation: {
            title: 'brand_briefing_strategy_title',
            desc: 'brand_briefing_strategy_desc',
        },
    },
    {
        route: '/brand/create/campaign/step2',
        title: 'Campaign Creation',
        video: 'https://www.loom.com/embed/f875e9f4e31a470189d4df57300f0599?t=90',
        locale: 'en',
        translation: {
            title: 'brand_briefing_content_title',
            desc: 'brand_briefing_content_desc',
        },
    },
    {
        route: '/brand/create/campaign/step3',
        title: 'Campaign Creation',
        video: 'https://www.loom.com/embed/f875e9f4e31a470189d4df57300f0599?t=312',
        locale: 'en',
        translation: {
            title: 'brand_briefing_timeline_title',
            desc: 'brand_briefing_timeline_desc',
        },
    },
    {
        route: '/brand/create/campaign/step4',
        title: 'Campaign Creation',

        video: 'https://www.loom.com/embed/f875e9f4e31a470189d4df57300f0599?t=387',
        locale: 'en',
        translation: {
            title: 'brand_briefing_placements_title',
            desc: 'brand_briefing_placements_desc',
        },
    },
    {
        route: '/brand/create/campaign/step5',
        title: 'Campaign Creation',
        video: 'https://www.loom.com/embed/f875e9f4e31a470189d4df57300f0599?t=442',
        locale: 'en',
        translation: {
            title: 'brand_briefing_audience_title',
            desc: 'brand_briefing_audience_desc',
        },
    },
    {
        route: '/brand/create/campaign/step6',
        title: 'Campaign Creation',
        video: 'https://www.loom.com/embed/f875e9f4e31a470189d4df57300f0599?t=488',
        locale: 'en',
        translation: {
            title: 'brand_briefing_influencer_detail_title',
            desc: 'brand_briefing_influencer_detail_desc',
        },
    },
    {
        route: '/brand/create/campaign/step7',
        title: 'Campaign Creation',
        video: 'https://www.loom.com/embed/f875e9f4e31a470189d4df57300f0599?t=509',
        locale: 'en',
        translation: {
            title: 'brand_briefing_distribution_usage_title',
            desc: 'brand_briefing_distribution_usage_desc',
        },
    },
    {
        route: '/brand/create/campaign/step8',
        title: 'Campaign Creation',
        video: 'https://www.loom.com/embed/f875e9f4e31a470189d4df57300f0599?t=610',
        locale: 'en',
        translation: {
            title: 'brand_briefing_distribution_exclusivity_title',
            desc: 'brand_briefing_distribution_exclusivity_desc',
        },
    },
    {
        route: '/brand/create/campaign/overview',
        title: 'Campaign Creation',
        video: 'https://www.loom.com/embed/f875e9f4e31a470189d4df57300f0599?t=673',
        locale: 'en',
        translation: {
            title: 'brand_briefing_overview_title',
            desc: 'brand_briefing_overview_desc',
        },
    },
    {
        route: '/brand/campaign/dashboard',
        title: 'Campaign Dashboard',
        video: 'https://www.loom.com/embed/f3e48b0e992a4a168035cf385cec484e',
        locale: 'en',
        translation: {
            title: 'brand_campaign_dashboard_title',
            desc: 'brand_campaign_dashboard_desc',
        },
    },
    {
        route: '/brand/campaign/discovery',
        title: 'Campaign Discovery',
        video: 'https://www.loom.com/embed/10bf535ccc1e42f48ee7bd5e6e84eb88',
        locale: 'en',
        translation: {
            title: 'brand_campaign_discovery_search_title',
            desc: 'brand_campaign_discovery_search_desc',
        },
    },
    {
        route: '/brand/campaign/discovery',
        title: 'Campaign Discovery',
        video: 'https://www.loom.com/embed/63fe524cbfb84fe0bf164cc152c1b3fb',
        locale: 'en',
        translation: {
            title: 'brand_campaign_discovery_favorites_title',
            desc: 'brand_campaign_discovery_favorites_desc',
        },
    },
    {
        route: '/brand/campaign/discovery',
        title: 'Campaign Discovery',
        video: 'https://www.loom.com/embed/8ba3a884cf8c413da6e8beba2868b917',
        locale: 'de',
        translation: {
            title: 'brand_campaign_discovery_search_title',
            desc: 'brand_campaign_discovery_search_desc',
        },
    },
    {
        route: '/brand/campaign/discovery',
        title: 'Campaign Discovery',
        video: 'https://www.loom.com/embed/7c58f31279ab4025be635bc90c0f37cf',
        locale: 'de',
        translation: {
            title: 'brand_campaign_discovery_favorites_title',
            desc: 'brand_campaign_discovery_favorites_desc',
        },
    },
    {
        route: '/brand/campaign/discovery/favorites',
        title: 'Bundle',
        video: 'https://www.loom.com/embed/63fe524cbfb84fe0bf164cc152c1b3fb',
        locale: 'en',
        translation: {
            title: 'brand_campaign_discovery_favorites_title',
            desc: 'brand_campaign_discovery_favorites_desc',
        },
    },
    {
        route: '/brand/campaign/discovery/favorites',
        title: 'Bundle',
        video: 'https://www.loom.com/embed/7c58f31279ab4025be635bc90c0f37cf',
        locale: 'de',
        translation: {
            title: 'brand_campaign_discovery_favorites_title',
            desc: 'brand_campaign_discovery_favorites_desc',
        },
    },
    {
        route: '/brand/discovery',
        title: 'Campaign Discovery',
        video: 'https://www.loom.com/embed/474a8d6158514a4696c08ea628a9134e',
        locale: 'en',
        translation: {
            title: 'brand_discovery_part1_title',
            desc: 'brand_discovery_part1_desc',
        },
    },
    {
        route: '/brand/discovery/lists',
        title: 'Campaign Discovery',
        video: 'https://www.loom.com/embed/db2c815dfc194cffab1030bbe118b91a',
        locale: 'en',
        translation: {
            title: 'brand_discovery_part2_title',
            desc: 'brand_discovery_part2_desc',
        },
    },
    {
        route: '/brand/discovery/lists/detail',
        title: 'Campaign Discovery',
        video: 'https://www.loom.com/embed/8d0828f5f71f465e8b9a3d4f715a8dcf',
        locale: 'en',
        translation: {
            title: 'brand_discovery_part3_title',
            desc: 'brand_discovery_part3_desc',
        },
    },
    {
        route: '/brand/campaign/book',
        title: 'Booking',
        video: 'https://www.loom.com/embed/37e0ba6d243f4a8fa10a96eecc584441',
        locale: 'en',
        translation: {
            title: 'brand_campaign_book_title',
            desc: 'brand_campaign_book_desc',
        },
    },
    {
        route: '/brand/campaign/book',
        title: 'Booking',
        video: 'https://www.loom.com/embed/6b3e7d463ab64a9d9cbe66e9513e8e00',
        locale: 'en',
        translation: {
            title: 'brand_campaign_offer_modal_title',
            desc: 'brand_campaign_offer_modal_desc',
        },
    },
    {
        route: '/brand/campaign/book/checkout',
        title: 'Booking',
        video: 'https://www.loom.com/embed/4ff58ad5f73e4237bc7bdb98b6662879',
        locale: 'en',
        translation: {
            title: 'brand_campaign_checkout_title',
            desc: 'brand_campaign_checkout_desc',
        },
    },
    {
        route: '/brand/campaign/manage',
        title: 'Manage',
        video: 'https://www.loom.com/embed/a0c60b20827240b0aed3585564e8a194',
        locale: 'en',
        translation: {
            title: 'brand_manage_title',
            desc: 'brand_manage_desc',
        },
    },
    {
        route: '/brand/campaign/manage',
        title: 'Manage',
        video: 'https://www.loom.com/embed/8452ebaf3d3d44a6878738a691e43c63',
        locale: 'en',
        translation: {
            title: 'brand_manage_posting_title',
            desc: 'brand_manage_posting_desc',
        },
    },
    {
        route: '/brand/campaign/measure',
        title: 'Measure',
        video: 'https://www.loom.com/embed/371741fc197943d4b1d086d095a46d0d',
        locale: 'en',
        translation: {
            title: 'brand_measure_title',
            desc: 'brand_measure_desc',
        },
    },
    {
        route: '/brand/campaign/options',
        title: 'Bundle',
        video: 'https://www.loom.com/embed/21047032269948f6bbe862685bd47aea',
        locale: 'en',
        translation: {
            title: 'brand_campaign_discovery_favorites_title',
            desc: 'brand_campaign_discovery_favorites_desc',
        },
    },
    //     {
    //     route: '/brand/campaign/options',
    //     title: 'Bundle',
    //     video: 'https://www.loom.com/embed/7c58f31279ab4025be635bc90c0f37cf',
    //     locale: 'de',
    //     translation: {
    //         title: 'brand_campaign_discovery_favorites_title',
    //         desc: 'brand_campaign_discovery_favorites_desc',
    //     },
    // },
    {
        route: '/settings/edit',
        title: 'Profile Settings',
        video: 'https://www.loom.com/embed/658119d2e59a4350ab2ffd3ad165a611',
        locale: 'en',
        translation: {
            title: 'settings_edit_title',
            desc: 'settings_edit_desc',
        },
    },
    {
        route: '/influencer/dashboard',
        video: 'https://www.loom.com/embed/0b5f12ca6b774fc8be8bcc27df286934',
        locale: 'en',
        translation: {
            title: 'influencer_dashboard_title',
            desc: 'influencer_dashboard_desc',
        },
    },
    {
        route: '/influencer/campaigns',
        video: 'https://www.loom.com/embed/eed8e13c808548b7a166d4972cf4dfcd',
        locale: 'en',
        translation: {
            title: 'influencer_dashboard_title',
            desc: 'influencer_dashboard_desc',
        },
    },
    {
        route: '/influencer/explore',
        video: 'https://www.loom.com/embed/36d9ce5c6a9d4425a4a21856b0537e4a',
        locale: 'en',
        translation: {
            title: 'influencer_explore_title',
            desc: 'influencer_explore_desc',
        },
    },
    {
        route: '/influencer/campaign/overview',
        video: 'https://www.loom.com/embed/deeaa8eedf654bc79d9a0090cacd6556',
        locale: 'en',
        translation: {
            title: 'influencer_briefing_title',
            desc: 'influencer_briefing_desc',
        },
    },
    {
        route: '/influencer/offers',
        video: 'https://www.loom.com/embed/2e398340e9fe44f7b14af0fd5d78204b',
        locale: 'en',
        translation: {
            title: 'influencer_offers_title',
            desc: 'influencer_offers_desc',
        },
    },
    {
        route: '/influencer/offers',
        video: 'https://www.loom.com/embed/15e8cb1ec5e34248abdba39d00252401',
        locale: 'en',
        translation: {
            title: 'influencer_offers_modal_title',
            desc: 'influencer_offers_modal_desc',
        },
    },
    {
        route: '/influencer/planner',
        video: 'https://www.loom.com/embed/a6dc078d203e4b818e29cf8e0e6cbf88',
        locale: 'en',
        translation: {
            title: 'influencer_planner_title',
            desc: 'influencer_planner_desc',
        },
    },
    {
        route: '/influencer/planner',
        video: 'https://www.loom.com/embed/bb9da1df51a943bfa7193cac53fad145',
        locale: 'en',
        translation: {
            title: 'influencer_planner_modal_title',
            desc: 'influencer_planner_modal_desc',
        },
    },
    {
        route: '/influencer/reporting',
        video: 'https://www.loom.com/embed/195fc6b3518746df82fb8a8646393d1e',
        locale: 'en',
        translation: {
            title: 'influencer_reporting_title',
            desc: 'influencer_reporting_desc',
        },
    },
    {
        route: '/influencer/reporting',
        video: 'https://www.loom.com/embed/84e9018f83284dbcba055403a9993222',
        locale: 'en',
        translation: {
            title: 'influencer_reporting_modal_title',
            desc: 'influencer_reporting_modal_desc',
        },
    },
    {
        route: '/agency/dashboard',
        video: 'https://www.loom.com/embed/1b18c6d0900c4fc2a1c1c4223310aa5c',
        locale: 'en',
        translation: {
            title: 'agency_dashboard_title',
            desc: 'agency_dashboard_desc',
        },
    },
];

// const brandTutorials = [];
// const influencerTutorials = [];
// const agencyTutorials = [];
